export interface ApplicationBranch {
  children: ApplicationLeaf[];
  id: string;
  label: string;
}

export interface ApplicationLeaf {
  appId: string;
  appName: string;
  appSwitcherCompliance: boolean;
  createDefaultShortcut: boolean;
  directiveId: string;
  hidden: boolean;
  label: string;
  shortcutLabel?: string;
  specialRole?: string;
  uri: string;
}

export type ApplicationNode = ApplicationBranch | ApplicationLeaf;

export type PublicType = ApplicationTypeInfo[];

export interface ApplicationTypeInfo {
  appId: string;
  directiveId: string;
  verbLabel: string;
  verbCode?: string;
}

interface ApplicationSwitcherModel {
  availableApplications: ApplicationNode[];
  publicTypeSupportingApplications: Map<string, PublicType>;
}

export const isApplicationLeaf = (
  applicationNode: ApplicationNode
): applicationNode is ApplicationLeaf => {
  return (applicationNode as ApplicationLeaf).directiveId !== undefined;
};

export const isApplicationBranch = (
  applicationNode: ApplicationNode
): applicationNode is ApplicationBranch => {
  return (applicationNode as ApplicationBranch).children !== undefined;
};

export default ApplicationSwitcherModel;
